﻿import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";

export class CZ03_2014 extends BaseForm
{
	override updateForm()
	{

	}
}